/**
 * Determines if the argument is object-like.
 *
 * A value is object-like if it's not `null` and has a `typeof` result of "object".
 *
 * @param  {*} x - The value to be checked.
 * @return {boolean}
 */

const isObject = x => (x && typeof x === 'object')

/**
 * Determines if the argument is a function.
 *
 * @param  {*} x - The value to be checked.
 * @return {boolean}
 */

const isFunction = x => typeof x === 'function'


let localStorageAvailable   = null;
let sessionStorageAvailable = null;

const isLocalStorageAvailable = () => {
    return localStorageAvailable ??= isStorageAvailable(window.localStorage);
}

const isSessionStorageAvailable = () => {
    return sessionStorageAvailable ??= isStorageAvailable(window.sessionStorage);
}

/**
 * Detects whether a web storage API is both supported and available.
 *
 * @link     https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
 * @param  {Storage} storage - The Storage instance.
 * @return {boolean} Returns TRUE if the `localStorage` API is supported and available.
 */
function isStorageAvailable(storage) {
    try {
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (error) {
        return error instanceof DOMException && (
            // everything except Firefox
            error.code === 22 ||
            // Firefox
            error.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            error.name === 'QuotaExceededError' ||
            // Firefox
            error.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
};

export {
    isObject,
    isFunction,
    isLocalStorageAvailable,
    isSessionStorageAvailable
}
